import { Stack } from '@mui/material';
import { concat } from 'lodash';
import React from 'react';
import CreateForm from 'src/components/ui-component/form-component/create-form/CreateForm';
import MarkdownRenderer from 'src/components/ui-component/markdown-renderer/MarkdownRenderer';
import { useApplication } from 'src/context/ApplicationContext';
import { PLATZHALTER_TEXT } from 'src/lib/constants/constant';
import { FormStrucItem } from 'src/lib/types/types';
import ApplicationHeading from 'src/pages/private/online-antrag/application-heading/ApplicationHeading';

// import schemas
import CreateTable from 'src/components/ui-component/form-component/create-form/CreateTable';
import VerwendungsnachweissSchema from 'src/lib/paths/verwendungsnachweis_FULL_Paths.json';
import { NonRequired } from 'src/lib/validation/ValidationTypes';
const VN_P = VerwendungsnachweissSchema.attributes;

export default function VNEinreichen({ untertitel, inhalt }: { untertitel: string; inhalt: string }) {
	const { application, setApplicationProperty, readOnly } = useApplication();

	return (
		<>
			<ApplicationHeading title={untertitel} description={PLATZHALTER_TEXT} />
			<MarkdownRenderer markdown={inhalt} />

			<Stack spacing={2} mb={2}>
				<CreateTable
					formStruc={formStrucNachweisHochladen()}
					formValues={application}
					updateFormValuesFunc={setApplicationProperty}
					readOnly={readOnly}
					columnsLabel={['Bezeichnung des Dokuments', 'Datei']}
				/>

				<CreateForm formStruc={formStrucHinweise()} formValues={application} updateFormValuesFunc={setApplicationProperty} readOnly={readOnly} />
			</Stack>
		</>
	);
}

const formStrucNachweisHochladen = () => {
	let stru: FormStrucItem[] = [
		{
			fields: [
				{
					type: 'label',
					path: 't.t',
					label: 'Mittelabruf',
					validation: [{ validateFunction: NonRequired }],
				},
				{
					...VN_P.Allgemein_Eingereichter_Mittelabruf,
					hideLabel: true,
					allowedFileNameKeywords: ['Mittelabruf']
				},
			],
		},
		{
			fields: [
				{
					type: 'label',
					path: 't.t',
					label: 'Verwendungsnachweis',
					validation: [{ validateFunction: NonRequired }],
				},
				{
					...VN_P.Allgemein_Eingereichter_Verwendungsnachweis,
					hideLabel: true,
					allowedFileNameKeywords: ['Verwendungsnachweis']
				},
			],
		},
	];

	return stru;
};
const formStrucHinweise = () => {
	let stru: FormStrucItem[] = [
		{
			fields: [VN_P.Allgemein_Hinweise_An_Die_HA],
			userProps: { columnToDivide: 1 },
		},
	];

	return stru;
};

export const getFormStrucAbschlussVN = () => {
	return concat(formStrucNachweisHochladen());
};
